/**
 * Created by JasonChou on 17/7/19.
 */
import React from 'react'
// import {Dimensions, Text, Image} from 'react-native'

import {Vertical, Horizontal, NetImage, Button, Text, Image} from "../../../components/index";
import {getProvinces, getCityInfo} from '../../../utils/cityUtils'
import ExamResultView from './ExamResultView'
import StudyRecordView from './StudyRecordView'
import {merge}from '../../../utils/uiUtils'

const screenWidth = window.screen.width;
const envPicWidth = parseInt((screenWidth - 90 - 15 * 2 - 3 * 3) / 3);

export default class UserInfoView extends React.Component {

    _toDesignApprove = () => {
        toast("已认证");
    }

    _isDesign() {
        const userInfo = this.props.data;
        const {design_v = 0} = userInfo;
        return design_v == 1;
    }

    _renderTattooer() {
        const userInfo = this.props.data;
        const {bao, v, handicraft_v, companyInfo, officialAccount} = userInfo;
        const hasCompany = !!companyInfo;

        return <Vertical style={infoStyle.container}>

            {!officialAccount && <Text style={merge(infoStyle.infoTitle)}>认证信息</Text>}
            {
                !officialAccount &&
                <Horizontal style={infoStyle.medalTotalContainer}>
                    <Button style={merge(infoStyle.medalbtn, bao ? infoStyle.orangeBg : infoStyle.grayBg)}
                    >{bao ? '签约保障' : '未签约保障'}</Button>
                    <Button style={merge(infoStyle.medalbtn, v ? infoStyle.blueBg : infoStyle.grayBg)}
                    >{v ? '实名认证' : '未实名认证'}</Button>
                    {!this._isDesign() &&
                    <Button style={merge(infoStyle.medalbtn, handicraft_v ? infoStyle.yellowBg : infoStyle.grayBg)}
                    >{handicraft_v ? '手艺认证' : '未手艺认证'}</Button>}
                    {this._isDesign() &&
                    <Button style={merge(infoStyle.medalbtn, this._isDesign() ? infoStyle.greenBg : infoStyle.grayBg)}
                    >{handicraft_v ? '设计认证' : '未设计认证'}</Button>}
                </Horizontal>
            }
            <Text style={merge(infoStyle.infoTitle, {marginBottom: 3,})}>个人简介</Text>
            {/*<Row label="所在地区"*/}
            {/*value={getCityInfo(userInfo.city) + (companyInfo ? ' · ' : '') + (companyInfo ? companyInfo.address : '')}/>*/}
            {!officialAccount && userInfo.sector == 30 && <Row label="从事职业：" value={'纹身师'}/>}
            {!officialAccount && userInfo.workVYear &&
            <Row label="工作年限：" value={'从业' + (userInfo.workVYear || '-') + '年'}/>}
            {!officialAccount && userInfo.tattooStyle &&
            <Row label="擅长风格：" value={userInfo.tattooStyle.replace(/#/g, ' ')}/>}
            {!officialAccount && userInfo.tattooElement &&
            <Row label="擅长元素：" value={userInfo.tattooElement.replace(/#/g, ' ')}/>}
            <Text style={merge(infoStyle.infoTitle, {marginBottom: 10})}>个人介绍</Text>
            <Text style={infoStyle.infoDes}>{userInfo.faith}</Text>

        </Vertical>
    }

    render() {
        const userInfo = this.props.data;

        return <Vertical style={{
            paddingBottom: 50
        }}>
            {this._renderTattooer()}
            {this._renderExamResult()}
            {this._renderStudyRecord()}
        </Vertical>

    }

    _renderExamResult() {
        const userInfo = this.props.data;
        if (userInfo && userInfo.healthExamination) {
            return <ExamResultView userInfo={userInfo}/>
        }
    }

    _renderStudyRecord() {
        const userInfo = this.props.data;
        if (userInfo && userInfo.healthExamination) {
            return <StudyRecordView userInfo={userInfo}/>
        }
    }
}


class Row extends React.Component {
    render() {
        return (<Horizontal style={infoStyle.row}>
            <Text style={infoStyle.rowLabel}>{this.props.label}</Text>
            {this.props.children ? this.props.children :
                <Text style={merge(infoStyle.rowValue, this.props.textStyle)}>{this.props.value}</Text>}
        </Horizontal>)
    }
}

const infoStyle = {
    container: {
        backgroundColor: '#fff',
        marginBottom: 20,
    },

    infoTitle: {
        fontSize: 16,
        color: "#232323",
        marginTop: 35,
        marginLeft: 15,
    },

    infoDes: {
        fontSize: 14,
        lineHeight: 1.8,
        color: "#727273",
        marginLeft: 13,
        marginRight: 15,
    },

    image: {
        width: 53,
        height: 17,
        borderRadius: 9,
        marginRight: 13,
    },

    company: {
        height: 45,
        width: screenWidth - 70 - 30 - 30,
        borderRadius: 5,
        backgroundColor: "#f4f4f4",
        alignItems: 'center',
    },

    comLogo: {
        width: 35,
        height: 35,
        borderRadius: 4,
        marginLeft: 5,
        marginRight: 10,
    },

    comName: {
        fontFamily: "PingFangSC-Regular",
        fontSize: 13,
        color: "#202020"
    },

    flex: {
        flex: 1,
    },

    arrow: {
        width: 6,
        height: 11,
        marginRight: 15,
    },

    shiMing: {
        backgroundColor: '#4888ff',
    },

    bao: {
        backgroundColor: '#ff751f',
    },

    shouYi: {
        backgroundColor: '#ffc804',
    },

    design: {
        backgroundColor: '#cc66ff',
    },

    medalWrapper: {
        marginRight: 35,
        alignItems: 'center',
    },

    medalContainer: {
        backgroundColor: '#c8c8c8',
        padding: 2,
        paddingLeft: 6, paddingRight: 6,
        borderRadius: 1
    },

    medalText: {
        fontSize: 10,
        color: '#fff'
    },
    label: {
        fontSize: 12,
        color: '#666',
        marginTop: 10
    },

    medalTotalContainer: {marginLeft: 13, marginTop: 13, marginBottom: 5,},
    medalbtn: {
        height: 30,
        borderRadius: 3,
        paddingLeft: 9,
        paddingRight: 9,
        fontSize: 12,
        color: "#ffffff",
        marginRight: 15,
        lineHeight: 2.5,
        // paddingTop:
    },
    orangeBg: {
        backgroundColor: '#FF6900',
    },
    grayBg: {
        backgroundColor: '#C6C6C6',
    },
    blueBg: {
        backgroundColor: '#007CFF',
    },
    yellowBg: {
        backgroundColor: '#FFAC00',
    },
    greenBg: {
        backgroundColor: '#00b900',
    },
    envContainer: {flex: 1, marginBottom: 10},

    envPic: {
        width: envPicWidth,
        height: envPicWidth,
        marginRight: 3,
        borderRadius: 2
    },

    row: {paddingLeft: 15, paddingRight: 15, paddingTop: 10, paddingBottom: 0},
    ImageRow: {
        width: 13,
        marginRight: 10,
    },
    rowLabel: {
        fontSize: 14,
        color: "#828282"
    },
    rowValue: {
        fontSize: 14,
        color: "#828282"
    },
    groupLabel: {marginTop: 20, fontSize: 16, marginLeft: 15, marginBottom: 10, color: '#333'},
    divider: {
        marginTop: 10,
        borderColor: '#ccc',
        borderBottomWidth: 0.3,
        marginLeft: 15,
        marginRight: 15
    },

};


// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/UserInfoView.js